import { render, staticRenderFns } from "./textarea.vue?vue&type=template&id=18d34a2b&scoped=true"
import script from "./textarea.vue?vue&type=script&lang=js"
export * from "./textarea.vue?vue&type=script&lang=js"
import style0 from "./textarea.vue?vue&type=style&index=0&id=18d34a2b&prod&scoped=true&lang=scss"
import style1 from "./textarea.vue?vue&type=style&index=1&id=18d34a2b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d34a2b",
  null
  
)

export default component.exports